export default __webpack_public_path__ + "static/media/article-1.2f99e6be.webp";